<template>
    <div class="overall-bg">
        <b-row>
            <b-col sm="10" xl="6" lg="6">
                <b-row class="pb-5">
                    <b-col>
                        <MemberDetails status="1" :dataObj="insert_data" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <!-- {{ contactlist }}a -->
                        <div>
                            <!-- {{ items }} -->
                            <ContactDetails :dataObj="contactlist" />

                        </div>
                    </b-col>
                </b-row>
                <!-- <b-row class="pb-5">
                    <b-col>
                        <BankInfo :dataObj="insert_bankdetails" />
                    </b-col>
                </b-row> -->

            </b-col>
            <b-col sm="10" xl="5" lg="5">
                <b-row class="pb-5 mt-5">
                    <b-col>
                        <SupplierBlackCardInfo :dataObj="insert_data" />
                    </b-col>
                </b-row>
                <!-- <b-row class="pb-5">
                <b-col>
                    <PaymentTerms />
                </b-col>
            </b-row>
            <b-row class="pb-5">
                <b-col>
                </b-col>
            </b-row> -->
            </b-col>
        </b-row>
    </div>
</template>
<script lang="ts">
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import { defineComponent, ref, h, computed, onMounted, watch } from "vue";
import Details from "../../../../../modules/Inventory/components/MasterDetails/Details.vue";
import MemberDetails from "../../../../../modules/Inventory/components/MasterDetails/MemberDetails.vue";
import ContactDetails from '../../../../../modules/Inventory/components/MasterDetails/ContactDetails.vue'
import Tax from '../Tax.vue'
import PaymentTerms from '../PaymentTerms.vue'
import BankInfo from '../BankInfo.vue'
import SupplierBlackCardInfo from '../SupplierBlackCardInfo.vue'
import service from "./../../../Service/ManufacturerService";
import ManufactureContactDetailsService from "../../../Service/ManufactureContactDetailsService";

export default defineComponent({
    components: {
        Details,
        MemberDetails,
        ContactDetails,
        Tax,
        PaymentTerms,
        BankInfo,
        SupplierBlackCardInfo,
    },

    setup() {


        const router = useRouter();
        const routers = useRoute();
        const ParamValues = ref({
            itemid: 0,
        });
        onMounted(() => {
            init();

        })
        let itemid = routers.query.id;
        ParamValues.value.itemid = Number(itemid);
        watch(
            () => routers.query.id,
            (newVal: any) => {
                debugger;

                ParamValues.value.itemid = Number(newVal);
                init();
            }
        );

        const insert_data = ref({
            CreatedAt: "",
            CreatedBy: 0,
            SupplierCatName: "",
            ModifiedAt: "",
            ModifiedBy: 0,
            HospitalId: 0,
            BranchId: 0,
            Id: 0,
            Code: "",
            Name: "",
            EntityId: 0,
            EntityOperationId: 0,
            StreetName: "",
            Landmark: "",
            Address: "",
            City: ref(),
            State: ref(),
            Country: ref(),
            Pin: "",
        });

        const addressdetails = ref({

            SwiftCode: "",
            IecCode: "",
            CdscApproval: ref(),
            TagUnit: ref(),

            StreetName: "",
            Landmark: "",
            Address: "",
            City: ref(),
            State: ref(),
            Country: ref(),
            Pin: "",
        });

        const insert_bankdetails = ref({
            BankName: "",
            BankAcNo: "",
            ReBankAcNo: "",
            BankBranch: "",
            IFSC: "",
        });

        const insert_contactdetails = ref({
            Id: 0,
            ManufactureId: 0,
            ContactPerson: "",
            ContactDesignation: "",
            Phone: "",
            Email: "",
            Web: "",
            LaneLine: "",
            Fax: "",
            index: 0
        });

        const insert_description = ref({
            Note: "",
        });
        let contactlist: any = ref([])
        let FileNames = ref();

        async function init() {
            debugger;
            console.log(ParamValues.value.itemid);
            if (ParamValues.value.itemid != undefined && !isNaN(ParamValues.value.itemid)) {
                try {
                    // label.value = "Update";
                    const EditID = ParamValues.value.itemid;
                    console.log(EditID);
                    try {
                        // loading.value = true;

                        const data_response = await service.Edit(EditID);
                        const data1 = data_response["result"];
                        console.log(data_response["result"]);

                        Object.keys(insert_data.value).forEach((key) => {
                            if (data1[key]) insert_data.value[key] = data1[key];
                        });

                        Object.keys(addressdetails.value).forEach((key) => {
                            if (data1[key]) addressdetails.value[key] = data1[key];
                        });
                        addressdetails.value.TagUnit = data1['TagUnit'].split(',').map(Number)
                        addressdetails.value.CdscApproval = data1['CdscApproval'] == true ? 1 : 0

                        Object.keys(insert_bankdetails.value).forEach((key) => {
                            if (data1[key]) insert_bankdetails.value[key] = data1[key];
                        });



                        Object.keys(insert_description.value).forEach((key) => {
                            if (data1[key]) insert_description.value[key] = data1[key];
                        });
                        const contactdata_response = await ManufactureContactDetailsService.Edit(EditID);
                        contactlist.value = contactdata_response["result"];
                        const ImgResponse = await service.GetFilesByManufactureId(EditID);
                        FileNames.value = ImgResponse["result"];
                        // console.log("File Names", FileNames.value);

                        // loading1.value = false;
                        // loading.value = false;
                        // loading.value = false;
                    } catch (error) {
                        // loading.value = false;
                        alert(error);
                    }
                } catch (error) {
                    console.error(error);
                }
            } else {
            }
        }

        return {
            insert_data,
            contactlist,
            insert_bankdetails



        };
    },
});
</script>